__turbopack_context__.v({
  "backToTop": "backToTop-module-scss-module__xE5foG__backToTop",
  "backtotoparrow": "backToTop-module-scss-module__xE5foG__backtotoparrow",
});
